import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { Link } from '@primer/react-brand';
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  Label,
  PropTableValues,
  Link,
  ComponentLayout,
  React
};